module.exports = __webpack_public_path__ + "img/color-13.ac6c58b.png";